import { render, staticRenderFns } from "./layoutLogin.vue?vue&type=template&id=72d71c0a&scoped=true"
import script from "./layoutLogin.vue?vue&type=script&lang=js"
export * from "./layoutLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d71c0a",
  null
  
)

export default component.exports